/* ui/game/configuration/RockConfiguration.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	to_number
} from "svelte/internal";

import {
	game,
	defaultConfig,
	configuration,
	configurationStore,
	GRID_SIZE
} from "../../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-1o1hhp2-style";
	style.textContent = ".container.svelte-1o1hhp2{display:grid;grid-template-columns:1fr 1fr;grid-gap:5px}.header.svelte-1o1hhp2{display:grid;justify-content:center;align-content:center}label.svelte-1o1hhp2{grid-column:1;white-space:nowrap}input.svelte-1o1hhp2{grid-column-start:3;width:4em;font-size:.7em}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div0;
	let t1;
	let div1;
	let label0;
	let t3;
	let input0;
	let input0_max_value;
	let t4;
	let label1;
	let t6;
	let input1;
	let mounted;
	let dispose;

	return {
		c() {
			div0 = element("div");
			div0.innerHTML = `<h4>Rock Configuration</h4>`;
			t1 = space();
			div1 = element("div");
			label0 = element("label");
			label0.textContent = "Number of Rocks";
			t3 = space();
			input0 = element("input");
			t4 = space();
			label1 = element("label");
			label1.textContent = "Initial HP";
			t6 = space();
			input1 = element("input");
			attr(div0, "class", "header svelte-1o1hhp2");
			attr(label0, "class", "svelte-1o1hhp2");
			attr(input0, "type", "number");
			attr(input0, "min", "0");
			attr(input0, "max", input0_max_value = GRID_SIZE * GRID_SIZE);
			attr(input0, "class", "svelte-1o1hhp2");
			attr(label1, "class", "svelte-1o1hhp2");
			attr(input1, "type", "number");
			attr(input1, "min", "1");
			attr(input1, "max", "9999");
			attr(input1, "class", "svelte-1o1hhp2");
			attr(div1, "class", "container svelte-1o1hhp2");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			insert(target, div1, anchor);
			append(div1, label0);
			append(div1, t3);
			append(div1, input0);
			set_input_value(input0, /*initialRocks*/ ctx[0]);
			append(div1, t4);
			append(div1, label1);
			append(div1, t6);
			append(div1, input1);
			set_input_value(input1, /*maxHp*/ ctx[1]);

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[3]),
					listen(input0, "change", /*reset*/ ctx[2]),
					listen(input1, "input", /*input1_input_handler*/ ctx[4]),
					listen(input1, "change", /*reset*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*initialRocks*/ 1 && to_number(input0.value) !== /*initialRocks*/ ctx[0]) {
				set_input_value(input0, /*initialRocks*/ ctx[0]);
			}

			if (dirty & /*maxHp*/ 2 && to_number(input1.value) !== /*maxHp*/ ctx[1]) {
				set_input_value(input1, /*maxHp*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { initialRocks, maxHp } = defaultConfig.rock;

	function reset() {
		const rock = { initialRocks, maxHp };
		configurationStore.update(configuration => ({ ...configuration, rock }));
		game.reset();
	}

	function input0_input_handler() {
		initialRocks = to_number(this.value);
		$$invalidate(0, initialRocks);
	}

	function input1_input_handler() {
		maxHp = to_number(this.value);
		$$invalidate(1, maxHp);
	}

	return [initialRocks, maxHp, reset, input0_input_handler, input1_input_handler];
}

class RockConfiguration extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1o1hhp2-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default RockConfiguration;